module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBubbleShow),
      expression: "isBubbleShow"
    }],
    staticClass: "bubble-wrapper"
  }, [(_vm.data_bubble) ? _c('div', {
    staticClass: "web-toast",
    class: _vm.fadeStatus
  }, [_c('img', {
    staticClass: "toast-head",
    attrs: {
      "src": _vm.data_head,
      "alt": "头像"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toast-info"
  }, [(_vm.data_bubble[_vm.nowIndex]) ? _c('p', {
    staticClass: "p-time"
  }, [_vm._v(_vm._s(_vm.data_bubble[_vm.nowIndex].time))]) : _vm._e(), _vm._v(" "), (_vm.data_bubble[_vm.nowIndex] && _vm.payProduct) ? _c('p', {
    staticClass: "p-user"
  }, [_vm._v(_vm._s(_vm.data_bubble[_vm.nowIndex].name) + "购买了该产品")]) : _c('p', {
    staticClass: "p-user"
  }, [_vm._v(_vm._s(_vm.data_bubble[_vm.nowIndex].name) + "进行了测试")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174fdcbb","hasScoped":false}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-bubble.vue
// module id = RkAO
// module chunks = 1 2 3 4